import React from 'react';

type ImportError = {
  row: number;
  message: string;
};

type ImportSummary = {
  created: number;
  updated: number;
  skipped: number;
  processed: number;
  errors: ImportError[];
};

type AirstripImportSummaryModalProps = {
  summary: ImportSummary;
  onClose: () => void;
};

export const AirstripImportSummaryModal: React.FC<AirstripImportSummaryModalProps> = ({ summary, onClose }) => (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-[2rem] border border-slate-200 shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-hidden">
      <div className="bg-slate-900 text-white p-6 flex items-center justify-between">
        <div>
          <h3 className="text-lg font-black uppercase tracking-[0.2em]">Import Summary</h3>
          <p className="text-[10px] uppercase tracking-widest text-slate-300 mt-1">Airstrip Registry Import Results</p>
        </div>
        <button
          onClick={onClose}
          className="w-10 h-10 rounded-xl bg-white/10 hover:bg-white/20 flex items-center justify-center text-white text-xl font-bold transition-all"
        >
          ×
        </button>
      </div>

      <div className="p-8 space-y-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { label: 'Created', value: summary.created },
            { label: 'Updated', value: summary.updated },
            { label: 'Skipped', value: summary.skipped },
            { label: 'Processed', value: summary.processed },
          ].map(item => (
            <div key={item.label} className="rounded-2xl border border-slate-200 bg-slate-50 p-4 text-center">
              <div className="text-xs uppercase tracking-widest text-slate-400 font-black">{item.label}</div>
              <div className="text-2xl font-black text-slate-900 mt-2">{item.value}</div>
            </div>
          ))}
        </div>

        <div className="rounded-2xl border border-slate-200 overflow-hidden">
          <div className="bg-slate-50 px-4 py-3 text-[10px] uppercase tracking-widest text-slate-400 font-black">
            Errors ({summary.errors.length})
          </div>
          {summary.errors.length === 0 ? (
            <div className="px-4 py-6 text-sm text-slate-500 font-bold">No errors detected.</div>
          ) : (
            <div className="max-h-64 overflow-y-auto divide-y divide-slate-100">
              {summary.errors.map((err, idx) => (
                <div key={`${err.row}-${idx}`} className="px-4 py-3 text-sm text-slate-700">
                  <span className="font-black text-rose-600 mr-2">Row {err.row}:</span>
                  <span className="font-semibold">{err.message}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="p-6 border-t border-slate-100 flex justify-end">
        <button
          onClick={onClose}
          className="px-6 py-3 bg-slate-100 text-slate-700 rounded-xl text-xs font-black uppercase tracking-widest hover:bg-slate-200 transition-all"
        >
          Close
        </button>
      </div>
    </div>
  </div>
);
